var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn--social\nbtn--facebook",attrs:{"type":"submit"},on:{"click":_vm.signInGoogle}},[_c('svgicon',{attrs:{"name":'google',"original":true,"width":"24","height":"24"}}),_vm._v("\n\n  "+_vm._s(_vm.$t('Log in with'))+" Google\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb78e4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/buttons/google/google.html
// module id = null
// module chunks = 